import apiFetch from 'utils/apiFetch';

export function getOptions(type, search) {
  return apiFetch(
    'GET',
    { endPoint: 'searchElements' },
    { type, search },
  );
}



// WEBPACK FOOTER //
// ./src/components/AutocompleteInput/modules/actions.js